// Shared dashboard components - Stat tiles, sparkline, route donut.
export function StatTile({ label, value, sub, accent = 'text-white', mono = true, testid }) {
  return (
    <div className="v-card p-5" data-testid={testid}>
      <div className="data-label">{label}</div>
      <div className={`mt-3 text-3xl ${accent} ${mono ? 'font-mono' : 'font-headings'} tracking-tight`}>{value}</div>
      {sub && <div className="text-[11px] text-slate-500 mt-1 font-mono">{sub}</div>}
    </div>
  );
}

export function Sparkline({ data, max }) {
  const peak = max ?? Math.max(...data.map(d => d.spend), 1);
  return (
    <div className="flex items-end gap-[3px] h-20 mt-3">
      {data.map((d, i) => {
        const h = peak > 0 ? Math.max(4, (d.spend / peak) * 100) : 4;
        return (
          <div
            key={i}
            className="spark-bar flex-1 cursor-pointer"
            style={{ height: `${h}%` }}
            title={`${d.date}: ₹${d.spend.toFixed(2)} · ${d.queries} queries`}
          />
        );
      })}
    </div>
  );
}

const ROUTE_COLORS = {
  'FAQ': '#10B981',
  'Semantic Cache': '#34D399',
  'Metadata DB': '#6EE7B7',
  'Summary Lookup': '#A7F3D0',
  'Gemini Flash': '#3B82F6',
  'GPT-4 Mini': '#60A5FA',
  'Claude Haiku': '#C17F59',
  'Claude Sonnet': '#EF4444',
};

export function RouteBreakdown({ byRoute }) {
  const total = Object.values(byRoute).reduce((s, n) => s + n, 0);
  if (total === 0) {
    return <div className="text-slate-500 text-[13px]">No queries in this window yet.</div>;
  }
  const rows = Object.entries(byRoute).sort((a, b) => b[1] - a[1]);
  return (
    <div className="space-y-2">
      {rows.map(([route, n]) => {
        const pct = (n / total) * 100;
        const color = ROUTE_COLORS[route] || '#A1A1AA';
        const isFree = ['FAQ', 'Semantic Cache', 'Metadata DB', 'Summary Lookup'].includes(route);
        return (
          <div key={route}>
            <div className="flex justify-between text-[12px] mb-1">
              <span className="text-white">{route}</span>
              <span className="font-mono text-slate-400">{n} · {pct.toFixed(1)}% {isFree && <span className="text-emerald-400">FREE</span>}</span>
            </div>
            <div className="w-full bg-white/5 h-1.5">
              <div className="h-1.5" style={{ width: `${pct}%`, background: color }} />
            </div>
          </div>
        );
      })}
    </div>
  );
}

export function CostByModel({ costByModel }) {
  const rows = Object.entries(costByModel).filter(([, v]) => v > 0).sort((a, b) => b[1] - a[1]);
  if (rows.length === 0) return <div className="text-slate-500 text-[13px]">No paid AI spend yet.</div>;
  const max = Math.max(...rows.map(([, v]) => v), 0.01);
  return (
    <div className="space-y-2">
      {rows.map(([m, v]) => (
        <div key={m} className="flex items-center gap-3">
          <div className="w-32 text-[12px] text-white">{m}</div>
          <div className="flex-1 bg-white/5 h-2">
            <div className="h-2 bg-[#C17F59]" style={{ width: `${(v / max) * 100}%` }} />
          </div>
          <div className="font-mono text-[12px] text-white w-20 text-right">₹{v.toFixed(2)}</div>
        </div>
      ))}
    </div>
  );
}
